// extracted by mini-css-extract-plugin
export default {"comments":"issue-comments_comments__RIw4W"};